
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/navigation/Sidebar';
import BottomNav from '../components/navigation/BottomNav';
import ProfileDropdown from '../components/navigation/ProfileDropdown';
import { UserRole } from '../types';

const UserLayout: React.FC = () => {
  return (
    <div className="min-h-dvh bg-brand-dark flex flex-col md:flex-row">
      <Sidebar role={UserRole.USER} />

      <main className="flex-1 overflow-auto pb-24 md:pb-6 md:px-8 px-4 pt-6">
        {/* Header with Safe Area Padding */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-brand-muted text-[10px] font-black uppercase tracking-[0.3em]">Nexus Terminal / User</h2>
            <div className="h-[1px] w-8 bg-brand-primary mt-1.5 shadow-[0_0_8px_#FFCE1B]"></div>
          </div>

          <ProfileDropdown />
        </div>

        <Outlet />
      </main>

      <BottomNav role={UserRole.USER} />
    </div>
  );
};

export default UserLayout;
